import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';

import Cancel from '@material-ui/icons/Cancel';

import ControlItem from './ControlItem';

import attendeesShape from '../../../../shapes/attendees';
import * as events from '../../../../events';
import * as selectors from '../../../../selectors';

const messages = defineMessages({
  KICK_FROM_MEETING: {
    id: 'KICK_FROM_MEETING',
    defaultMessage: 'Kick from meeting',
  },
});

const KickControl = ({
  type,
  variant,
  attendee,
  restrictAttendee,
  myAttendee,
  attendees,
  handleClose,
}) => {
  // I have no idea how attendee is ever null here, but it is
  if (!attendee || _.isEmpty(attendee)) return null;

  if (!myAttendee) return null; // myAttendee shouldn't ever be null either, but it is

  if (attendee.isSelf) return null;

  // eslint-disable-next-line max-len
  const stateAttendee = attendees.find((sAttendee) => sAttendee.attendee_id === attendee.attendee_id);
  if (!stateAttendee || _.isEmpty(stateAttendee)) return null;

  // access restrictions based on roles
  switch (myAttendee.role) {
    case 'host':
      if (['host'].includes(stateAttendee.role) && !myAttendee.isOwner) {
        return null;
      }
      break;
    case 'presenter':
      if (['host', 'presenter'].includes(stateAttendee.role)) {
        return null;
      }
      break;
    case 'attendee':
      return null;
    default:
      return null;
  }

  const intl = useIntl();

  const isToggled = Boolean(stateAttendee.access_restricted); // this should never be true

  const onToggle = () => {
    restrictAttendee(stateAttendee, 'access');
    handleClose();
  };

  return (
    <ControlItem
      type={type}
      variant={variant}
      onClick={onToggle}
      isToggled={isToggled}
      enabledIcon={<Cancel />}
      enabledTooltip={intl.formatMessage(messages.KICK_FROM_MEETING)}
    />
  );
};

KickControl.propTypes = {
  type: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  attendee: attendeesShape.propTypesShape.isRequired,
  myAttendee: attendeesShape.propTypesShape.isRequired,
  restrictAttendee: PropTypes.func.isRequired,
  attendees: attendeesShape.arrayOfShapes.isRequired,
  handleClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  myAttendee: selectors.selectMyAttendee(state),
  attendees: selectors.selectConnectedAttendees(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  restrictAttendee: events.restrictAttendee,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(KickControl);
